export class ModalView {
  createDoms() {
    let modal = document.createElement('div');
    modal.className = 'modal';

    let window = document.createElement('div');
    window.className = 'window';
    modal.appendChild(window);

    let head = document.createElement('div');
    head.className = 'head';
    window.appendChild(head);

    let title = document.createElement('div');
    title.className = 'title';

    let titleText = document.createElement('div');
    title.appendChild(titleText);

    let titleStatus = document.createElement('div');
    titleStatus.className = 'title-status';
    title.appendChild(titleStatus);

    head.appendChild(title);


    let close = document.createElement('div');
    close.className = 'close';
    head.appendChild(close);

    let content = document.createElement('div');
    content.className = 'content';
    content.innerHTML = content || '';
    window.appendChild(content);
    return { modal, window, head, titleText, titleStatus, close, content };
  }
}
